<template>
  <div class="monthly-visualization-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-data"></i> Monthly Visualization Report</span>
      </div>

      <el-form :inline="true" :model="query" size="medium">

        <el-form-item label="Year">
          <el-select v-model="query.year" placeholder="Year" style="width:100px">
            <el-option
                v-for="item in year_option"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-download" @click="Export()">Export</el-button>
        </el-form-item>
      </el-form>


    </el-card>
  </div>
</template>

<script>
import { monthlychargeVisualizationExcel } from "@/api/report";
import { currentYear } from '@/utils'
export default {

  data(){
    return {
      query: {
        year: currentYear()
      },
      year_option: [],
    
    }
  },
  methods:{

    Export(){
      monthlychargeVisualizationExcel(this.query)
    },

    dropdownMonthYear() {
      

      for (let y = (currentYear() - 5); y <= currentYear(); y++) {
        this.year_option.push({ value: y.toString() });
      }
    },
    
  },
  created(){
    this.dropdownMonthYear()
   
  }
}
</script>

<style lang="scss">
.monthly-visualization-report{
    .el-table .closed {
    background: #ffdede;
  }

  .el-table .suspended {
    background: #f3f3f3;
  }

  .pagination-block{
    margin-top: 10px;
  }

  .panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 18px;
  }

  .card-panel {
    height: 108px;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);
    
    &:hover {
      cursor: pointer;
      background-color: #e8f3ff;
      -webkit-box-shadow: 4px 4px 40px rgba(0,0,0,0.05);
      box-shadow: 4px 4px 40px #409eff29;
      border-color: #deeeff;
      -webkit-transition: background-color .2s ease-out;
      transition: background-color .2s ease-out;
    }

    .icon-open {
      color: #40c9c6;
    }

    .icon-missing {
      color: #f4516c;
    }

    .icon-insufficient {
      color: #e6a23c;
    }

    .icon-collected {
      color: #36a3f7;
    }

    .card-panel-icon-wrapper {
      position: absolute;
      margin: 14px 0 0 6px;
      padding: 10px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 45px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 10px;
      margin-top: 20px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 5px;
        text-align: right;
      }

      .card-panel-num {
        font-size: 20px;
        text-align: right;
        margin-bottom: 7px;
      }
      .card-panel-amount {
        text-transform: uppercase;
        font-size: 14px;
        text-align: right;
        margin-bottom: 7px;
        color: 969696;
      }
      .card-panel-acc {
        text-align: right;
        margin-bottom: 3px;
      }
      .card-panel-type {
        text-align: right;
      }
    }
  }
}

@media (max-width: 550px) {
  // .card-panel-description {
  //   display: none;
  // }

    .card-panel-icon-wrapper {
    float: none !important;
    width: 0px;
    height: 0px;
    padding: 0 !important;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 0px auto !important;
      float: none !important;
    }
  }
}
}
</style>